import { Box } from '@mui/material';
import { useAdvice } from '@prismamedia/one-components';
import type { FC, ReactElement } from 'react';
import { cloneElement, useCallback, useRef } from 'react';
import { CATEGORY_CREATION_RIGHTS_DENIED_MESSAGE } from '../../constants';

interface CreationRightsWrapperProps {
  canCreate: boolean;
  children: ReactElement;
}

export const CreationRightsWrapper: FC<CreationRightsWrapperProps> = ({
  canCreate,
  children,
}) => {
  const wrapperRef = useRef<HTMLElement>(null);
  const { openAdvice, closeAdvice } = useAdvice();

  const handleMouseEnter = useCallback(() => {
    openAdvice({
      anchorRef: wrapperRef,
      content: CATEGORY_CREATION_RIGHTS_DENIED_MESSAGE,
      hasCross: false,
      PopperProps: {
        keepMounted: false,
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundariesElement: 'window',
              enabled: false,
              escapeWithReference: true,
            },
          },
        ],
        style: { width: '310px' },
      },
      zIndex: 1,
    });
  }, [openAdvice]);

  const handleMouseLeave = useCallback(() => {
    closeAdvice();
  }, [closeAdvice]);

  if (canCreate) {
    return children;
  }

  return (
    <Box
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ display: 'inline-flex' }}
    >
      {cloneElement(children, {
        disabled: true,
        onClick: undefined,
      })}
    </Box>
  );
};
